import React, { useState, useEffect } from 'react';
import { Box, IconButton } from '@mui/material';
import { Circle } from '@mui/icons-material';

interface ImageCarouselProps {
  images: Array<{
    url: string;
    backgroundSize?: 'cover' | 'contain' | 'auto';
    backgroundPosition?: string;
  }>;
  interval?: number;
}

const ImageCarousel: React.FC<ImageCarouselProps> = ({
  images,
  interval = 5000
}) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentImageIndex((prevIndex) =>
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
    }, interval);

    return () => clearInterval(timer);
  }, [images.length, interval]);

  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundImage: `url(${images[currentImageIndex].url})`,
        backgroundSize: 'cover',
        backgroundPosition: images[currentImageIndex].backgroundPosition || 'center',
        backgroundRepeat: 'no-repeat',
        transition: 'background-image 1s ease-in-out',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.3)',
          zIndex: 1
        }
      }}
    >
      {/* Carousel Indicators */}
      <Box
        sx={{
          position: 'absolute',
          bottom: 20,
          left: '50%',
          transform: 'translateX(-50%)',
          display: 'flex',
          gap: 1,
          zIndex: 2
        }}
      >
        {images.map((_, index) => (
          <IconButton
            key={index}
            onClick={() => setCurrentImageIndex(index)}
            sx={{
              p: 0.5,
              color: index === currentImageIndex ? 'white' : 'rgba(255, 255, 255, 0.5)',
              '&:hover': {
                color: 'white'
              }
            }}
          >
            <Circle sx={{ fontSize: index === currentImageIndex ? 16 : 12 }} />
          </IconButton>
        ))}
      </Box>
    </Box>
  );
};

export default ImageCarousel; 